import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Logo from './Logo';
import Icon from './Icon';

const links = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/about', label: 'About' },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onKey = (e) => e.key === 'Escape' && setMenuOpen(false);
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [menuOpen]);

  const navClass = ({ isActive }) =>
    `text-sm font-medium transition ${isActive ? 'text-white' : 'text-slate-400 hover:text-white'}`;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen ? 'border-b border-ink-700 bg-ink-950/90 backdrop-blur-md' : 'border-b border-transparent'
      }`}
    >
      <div className="container-site flex h-16 items-center justify-between md:h-20">
        <Link to="/" aria-label="Gomagen Labs home">
          <Logo />
        </Link>

        <nav className="hidden items-center gap-8 md:flex" aria-label="Main">
          {links.map((link) => (
            <NavLink key={link.to} to={link.to} end className={navClass}>
              {link.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn-primary py-2.5">
            Start a project
          </Link>
        </nav>

        <button
          type="button"
          className="-mr-2 rounded-md p-2 text-white md:hidden"
          onClick={() => setMenuOpen((open) => !open)}
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        >
          <Icon name={menuOpen ? 'close' : 'menu'} />
        </button>
      </div>

      {menuOpen && (
        <nav
          id="mobile-menu"
          aria-label="Mobile"
          className="container-site flex h-[calc(100dvh-4rem)] flex-col gap-2 border-t border-ink-700 bg-ink-950 pb-10 pt-6 md:hidden"
        >
          {[...links, { to: '/contact', label: 'Contact' }].map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end
              className={({ isActive }) =>
                `rounded-md px-3 py-3 font-display text-2xl font-semibold ${
                  isActive ? 'text-signal-400' : 'text-white'
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn-primary mt-auto">
            Start a project
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Header;
